import React, { memo, useMemo } from 'react';
import { getContext, Symbols } from 'choerodon-ui/shared';
import { getPrefixCls } from '../configure/utils';
const AvatarContext = getContext(Symbols.AvatarContext, { getPrefixCls });
const BaseAvatarContextProvider = function AvatarContextProvider(props) {
    const { children, size, getPrefixCls: getGlobalPrefixCls } = props;
    const value = useMemo(() => ({
        size,
        getPrefixCls: getGlobalPrefixCls,
    }), [getGlobalPrefixCls, size]);
    return (React.createElement(AvatarContext.Provider, { value: value }, children));
};
BaseAvatarContextProvider.displayName = 'AvatarContextProvider';
export const AvatarContextProvider = memo(BaseAvatarContextProvider);
export default AvatarContext;
